'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxLoggerMiddleware = require('./reduxLoggerMiddleware');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reduxLoggerMiddleware).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-logger-middleware/dist/main/index.js
// module id = 527
// module chunks = 0